import VehicleGnc from './VehicleGnc'

export default VehicleGnc
